module.exports = __webpack_public_path__ + "static/img/jygl615.2a43071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jygl615.png
// module id = DdsP
// module chunks = 73